// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-date-range-picker .dropdown{width:100%;margin:0}.form-date-range-picker .lx-date-range-picker__button{width:unset;white-space:nowrap}.form-date-range-picker .dropdown-toggle{text-align:left !important}.form-date-range-picker .dropdown-toggle::after{position:absolute;top:calc(50% - .15em);right:.75rem}", ""]);
// Exports
module.exports = exports;
